import { CopyButton } from '@/shared/ui/CopyButton/CopyButton';
import classes from './formatterStyles.module.scss';

/** Сокращает идентификатор для компактного отображения, сохраняя короткие значения целиком */
export const formatShortId = (id: string, visibleCharacters = 8): string => (
    id.length > visibleCharacters
        ? `${id.slice(0, visibleCharacters)}…`
        : id
);

/** Форматирует идентификатор для отображения */
export const formatIdCell = (
    id: string | null | undefined,
    fallback = '—',
): React.ReactNode => id
        ? (
            <div className="flex align-items-center gap-2">
                <code
                    className={`text-sm truncate font-mono ${classes.shortId}`}
                    title={`Полный ID: ${id}`}
                >
                    {id.substring(0, 8)}...
                </code>
                <CopyButton
                    value={id}
                    label="Копировать ID"
                />
            </div>
        )
        : fallback;
